module.exports = __webpack_public_path__ + "81e46b05b917b26aa12971e260435bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/first.jpg
// module id = 112
// module chunks = 0